import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b14e81e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "http://10.10.40.162/chatbot/qYyLkRy5TpHFmPQF",
    style: {"width":"100%","height":"100%","min-height":"700px"},
    frameborder: "0",
    allow: "microphone"
  }, "\r\n      ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { GetMoreexportData } from "@/service/main/statistical/";
import { exportExcel } from "@/utils/exportExcel";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const searchQuery = ref("");
const searching = ref(false);
const fileList = ref([]);
const fileDownloadUrl = ref("");
const fileDownloadName = ref("");

// watch(searchQuery, (val) => {
//   if (val == "") {
//     tableData.value = [];
//   }
// });

// 表格数据
const tableData = ref([]);
const tableColumns = ref([
  { prop: "code", label: "品号" },
  { prop: "name", label: "品名" },
  { prop: "number", label: "数量" },
  { prop: "date", label: "日期", width: "180" }
]);

const handleSearch = async () => {
  if (!searchQuery.value.trim()) return;

  searching.value = true;
  tableData.value = []; // 清空旧数据
  fileDownloadUrl.value = ""; // 清空文件下载链接

  try {
    // API调用
    const { data } = await GetMoreexportData({
      NaturalQuery: searchQuery.value
    });
    console.log(data, "response");
    if (data.filePath) {
      // 如果有文件路径，显示下载提示
      fileDownloadUrl.value = data.filePath;
      // fileDownloadName.value = '';
    }

    if (data.details && data.details.length > 0) {
      // 填充表格数据
      tableData.value = data.details;
      tableColumns.value = [];
      for (var key in tableData.value[0]) {
        let item = { prop: key, label: key };
        tableColumns.value.push(item);
      }
    } else {
      tableData.value = [];
      tableColumns.value = [];
    }
    console.log(tableColumns.value, "tableColumns.value");
  } catch (error) {
    ElMessage.error("搜索失败: " + error.message);
  } finally {
    searching.value = false;
  }
};

const mockApiCall = (query) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // 根据查询内容返回不同结果
      if (query.includes("文件")) {
        resolve({
          filePath: "https://example.com/sample-report.pdf",
          fileName: "分析报告.pdf"
        });
      } else if (query.includes("空")) {
        resolve({}); // 返回空数据
      } else {
        resolve({
          tableData: generateMockTableData()
        });
      }
    }, 1500);
  });
};

const generateMockTableData = () => {
  const data = [];
  for (let i = 1; i <= 10; i++) {
    data.push({
      id: i,
      name: `项目 ${i}`,
      value: Math.random().toFixed(4) * 100,
      date: new Date().toLocaleString()
    });
  }
  return data;
};

const downloadFile = (filePath, fileName = "") => {
  // const link = document.createElement("a");
  // link.href = filePath;
  // link.target = "_blank";

  // // 如果没有提供文件名，从URL中提取
  // const finalFileName = fileName || filePath.split("/").pop();
  // console.log(filePath,finalFileName,'finalFileName');

  // link.download = finalFileName;

  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  let entozh = {};
  tableColumns.value.forEach((item: any) => {
    entozh[item.label] = item.prop;
  });
  console.log(entozh, "entozh");

  const finalFileName = fileName || filePath.split("/").pop();
  exportExcel(tableData.value, entozh, "xlsx", finalFileName);
};

const handleFileChange = (file) => {
  ElMessage.info(`已选择文件: ${file.name}`);
  fileList.value = [file];
  // 这里可以添加文件上传逻辑
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})